import React, { FunctionComponent } from "react";
import { styled, media } from "@iventis/styles";

import { CloseButton } from "./close-icon";
import { TextDisplayAndEditor } from "./text-display-and-editor";

interface ImageFullScreenViewerProps {
    name: string;
    imageUrl: string;
    dataTestId?: string;
    onNameChange?: (name: string) => void;
    onClose?: () => void;
}

export const ImageFullScreenViewer: FunctionComponent<ImageFullScreenViewerProps> = ({ name, imageUrl, dataTestId, onClose, onNameChange }) => (
    <ImageFullScreenViewerContainer data-testid={dataTestId}>
        <div className="image-header">
            {onNameChange ? <TextDisplayAndEditor text={name} onTextChange={onNameChange} dataTestId={dataTestId} /> : <div>{name}</div>}
            {onClose && <CloseButton className="close-button" onMouseDown={onClose} dataTestId="close-image-modal" />}
        </div>
        <img src={imageUrl} alt={name} />
    </ImageFullScreenViewerContainer>
);

const ImageFullScreenViewerContainer = styled.div`
    ${media.extraExtraLarge} {
        height: auto;
    }

    height: 90vh;

    padding: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .close-button {
        position: relative;
    }

    .image-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 100%;
    }

    img {
        max-width: 90%;
        max-height: 90%;
    }
`;
